import { module } from 'modujs';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);
        
        this.items = [...this.el.querySelectorAll('.o-footer_carousel_item')];
        this.currentIndex = 0;
        this.maxIndex = this.items.length - 1;

        this.progressAnim = gsap.timeline({ repeatDelay: 4, repeat: -1, paused: true});
        this.progressAnim.call(() => { this.playProgress(); });
    }

    playProgress() {
        let newIndex = this.currentIndex == this.maxIndex ? 0 : this.currentIndex + 1;
        this.showItem(newIndex);
    }

    showItem(index) {
        // If current is already active
        if (this.currentIndex == index) {
            return;
        }

        let oldItem = this.items[this.currentIndex];
        if (oldItem) {
            oldItem.classList.remove('-active');
        }

        this.currentIndex = index;

        let newItem = this.items[this.currentIndex];        
        newItem.classList.add('-active');
    }

    toggle(e){
        if (e.way == 'leave') {
            if (this.progressAnim) {
                this.progressAnim.pause();
            }
        } else {
            if (this.progressAnim) {
                this.progressAnim.play();
            }
        }
    }
}
